module.exports = __webpack_public_path__ + "img/3.d788e0b6.webp";